import React from "react";

export default function Checkbox({ label, checked, onChange }) {
  return (
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        checked={!!checked} // garante true/false sempre
        onChange={onChange}
      />
      <label className="form-check-label">{label}</label>
    </div>
  );
}